import {blindBoxRandom, fortressRandom, getOriginTileSet, splitThree} from "@/utils/random";
import {colorTrans, displayTrans, teamColorTrans} from "@/utils/display";

export const GameUtils = {
    blindBoxRandom,
    fortressRandom,
    getOriginTileSet,
}

export const GameDisplay = {
    displayTrans,
    colorTrans,
    teamColorTrans,
}

export const PropUtils = {
    splitThree
}
